import { render } from "./MenuProfile.vue?vue&type=template&id=17ad1294&scoped=true"
import script from "./MenuProfile.vue?vue&type=script&lang=js"
export * from "./MenuProfile.vue?vue&type=script&lang=js"

import "./MenuProfile.vue?vue&type=style&index=0&id=17ad1294&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ad1294"]])

export default __exports__